import React from 'react';
import { Drawer, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import RecentChangeCard from './RecentChangeCard';
import styles from './styles';

const useStyles = makeStyles(styles);

const RecentChangesDrawer = ({ open, onClose, items }) => {
  const classes = useStyles();

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ className: classes.paper }}>
      <div className={classes.header}>
        <IconButton onClick={onClose} aria-label="Back" size="small">
          <KeyboardArrowLeft />
        </IconButton>
        <span className={classes.headerTitle}>Show Recent Changes ({items.length})</span>
        <IconButton className={classes.headerSpacer} size="small" tabIndex={-1} aria-hidden>
          <KeyboardArrowLeft />
        </IconButton>
      </div>
      <div className={classes.list}>
        {items.map((change) => (
          <RecentChangeCard key={change._id} change={change} classes={classes} />
        ))}
      </div>
    </Drawer>
  );
};

export default RecentChangesDrawer;
